<template>
  <div v-if="owner != null">
    <add-bank-account :is-active.sync="isAdding" @added="accountAdded" :owner="owner" />
    <data-table
      title="Bank Accounts"
      ref="table"
      :url="url"
      :headers="headers"
      searchable
      :archive="false"
      @update-archived="(status) => (this.showArchived = status)"
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template slot="action.icons">
        <v-btn color="primary" @click="isAdding = true">
          Add Bank Account
          <v-icon class="ml-2" color="light-blue lighten-4">
            mdi-account-plus
          </v-icon>
        </v-btn>
      </template>
      <span slot="item.type" slot-scope="{ item }" v-text="getUserType(item)" />

      <template slot="item.status" slot-scope="{ item }">
        <v-icon color="success" v-if="item.is_active">mdi-progress-check</v-icon>
        <v-icon color="warning" v-else>mdi-information-outline</v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
export default {
  components: { AddBankAccount: require("./addBankAccountForm").default },
  props: {
    owner: {
      required: true,
    },
  },

  data() {
    return {
      currentFilter: "all",
      isAdding: false,
      showArchived: false,
      accounts: null,
      headers: this.pairTableLabelWithValue({
        Title: "account.title",
        "Bank Name": "bank_name",
        Country: "account.country",
        "IBAN CODE": "iban",
        BIC: "bic",
        Status: "status",
      }),
    };
  },
  computed: {
    url() {
      return `api/v1/userBankAccounts/all/${this.owner.id}`;
    },
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
    showArchived: function (val) {
      if (val) {
        this.url = `api/v1/userBankAccounts/all/${this.owner.id}`;
      } else {
        this.url = `api/v1/userBankAccounts/all/${this.owner.id}`;
      }
    },
  },
  methods: {
    showDetails({ id }) {
      this.$router.push({ name: "bankaccounts.show", params: { id } });
    },
    updateAccount(account) {
      if (account) {
        this.account = account;
      }
    },
    accountAdded({ message }) {
      this.isAdding = false;
      this.$refs.table.fetchData();
      Notify.success(message);
    },
  },
};
</script>
